// clickable-link.pipe.ts

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "clickableLink",
    standalone: false
})
export class ClickableLinkPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    const urlRegex = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
    return value.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
  }
}
